import React from 'react'
import { Link } from 'react-router-dom';
import Teamdtlimg01 from '../../../assets/images/blog1.png';
import Teamdtlimg02 from '../../../assets/images/blog2.png';
import Teamdtlimg03 from '../../../assets/images/blog3.png';
import Logo from '../../../assets/images/logo2.png'
import Teamdtlimg04 from '../../../assets/images/blog/blog-standard-image-4.jpg';
import Teamdtlimg05 from '../../../assets/images/blog/blog-standard-image-5.jpg';
import Teamdtlimg06 from '../../../assets/images/blog/blog-standard-image-6.jpg';
import Teamdtlimg07 from '../../../assets/images/blog/blog-standard-image-7.jpg';



const Teamdetail = () => {
    return (
        <div className="blog-list-section" >
            <div className="container">
                <div className="row gutter-y-30">
                    <div className="col-lg-8">
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img 
                                            src={Teamdtlimg01}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                {/* <div className="blog-item-tagline">
                                    <Link to="#">FIRST LOAN</Link>
                                </div> */}
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By The NRI Advisor </Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="#">7 Essential Personal Finance Tips for NRIs You Need to Know</Link>
                                    </h3>
                                    <p>
                                    Managing personal finances can be complex, especially for Non-Resident Indians (NRIs) who must navigate the financial systems of their country of residence and India. Proper financial planning ensures that NRIs can maximize their earnings, save efficiently, and invest wisely. Here are seven essential personal finance tips that every NRI should know. 1. Taxation As an […]


                                    </p>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading </span>
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails2">
                                        <img
                                            src={Teamdtlimg02}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                {/* <div className="blog-item-tagline">
                                    <Link to="#">CREDIT SCORE</Link>
                                </div> */}
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By The NRI Advisor</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2025</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="#">
                                        10 Things Every NRI Should Know About OCI Card
                                        </Link>
                                    </h3>
                                    <p>
                                    For Non-Resident Indians (NRIs) and Persons of Indian Origin (PIO), the Overseas Citizen of India (OCI) card offers several advantages and privileges. Understanding the benefits, application process, and limitations of the OCI card can help streamline your connection with India. Here are 10 essential things every NRI should know about the OCI card:  What is […]
                                    </p>
                                    <Link to="/Blogdetails2" className="btn-link">
                                        <span>continue reading </span>
                                        <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails3">
                                        <img
                                            src={Teamdtlimg03}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                {/* <div className="blog-item-tagline">
                                    <Link to="#">LOAN</Link>
                                </div> */}
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By The NRI Advisor</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="#">10 Ways NRIs Can Resolve Family Disputes From Afar</Link>
                                    </h3>
                                    <p>
                                    Being a Non-Resident Indian (NRI) comes with its own set of challenges, especially when it comes to managing family disputes from a distance. Whether it’s disagreements over property, financial matters, or interpersonal conflicts, here are ten effective ways NRIs can navigate and resolve family disputes while being geographically distant. 1.    Open Communication Channels Maintaining open […]
                                    </p>
                                    <Link to="/Blogdetails3" className="btn-link">
                                        <span>continue reading </span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* <div className="blog-block">
                            <div className="blog-list-item">
                                <div className="blog-image">
                                    <Link to="/Blogdetails">
                                        <img
                                            src={Teamdtlimg04}
                                            alt="blog-image"
                                        />
                                    </Link>
                                </div>
                                <div className="blog-item-tagline">
                                    <Link to="#"> INTEREST RATE</Link>
                                </div>
                                <div className="blog-item-meta">
                                    <p>
                                        <Link to="#">By Martin</Link>
                                    </p>
                                    <p>
                                        <Link to="#">On 29 Sup 2024</Link>
                                    </p>
                                </div>
                                <div className="blog-item-details">
                                    <h3>
                                        <Link to="#">
                                            The Benefits of Fixed vs. Variable Loan Interest Rates
                                        </Link>
                                    </h3>
                                    <p>
                                        Fixed and variable interest rates offer different advantages.
                                        Explore the pros and cons of each to determine which type best
                                        suits your financial situation and long-term goals.
                                    </p>
                                    <Link to="/Blogdetails" className="btn-link">
                                        <span>continue reading </span> <i className="flaticon-next" />
                                    </Link>
                                </div>
                            </div>
                        </div> */}
                        <div className="blog-block mb-0">
                            <ul className="pagination">
                                <li className="active">
                                    <Link to="#">1</Link>
                                </li>
                                <li>
                                    <Link to="#">2</Link>
                                </li>
                                <li>
                                    <Link to="#">3</Link>
                                </li>
                                <li>
                                    <Link to="#">4</Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fa-solid fa-angles-right" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div
                            className="blog-sidebar stcky"
                            style={{
                                width: "100%",
                                maxWidth: "100%",
                                overflow: "hidden",
                                boxSizing: "border-box",
                                fontSize: "0.92rem", // or try 0.9rem or 14px for smaller text
                                lineHeight: "1.4"
                            }}
                        >
                            <div className="blog-block">
                                <div className="blog-serch-widget">
                                    <form action="#">
                                        <input type="search" placeholder="Search " />
                                        <button type="submit">
                                            <i className="flaticon-search-interface-symbol" />
                                        </button>
                                    </form>
                                </div>
                            </div>
                            {/* <div className="blog-block">
                                <div className="category-widget">
                                    <h4>Category</h4>
                                    <ul>
                                        <li className="active">
                                            <Link to="#">Home Loan</Link> <span>(05)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Wedding Loan</Link> <span>(09)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Mortgage Loan</Link> <span>(04)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Business Loan</Link> <span>(06)</span>
                                        </li>
                                        <li>
                                            <Link to="#">Education loan</Link> <span>(08)</span>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="blog-block">
                                <div className="recent-blog-widget" style={{display: "flex", flexDirection: "column", flex: "1", gap: "10px"}} >
                                    <h4>Recent Menu</h4>
                                    <div className="recent-blog-widget-item" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}} >
                                        <img className='img-fluid'
                                            src={Teamdtlimg03}
                                            alt="blog-image"
                                        />
                                        <div className="recent-blog-widget-item-title" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}}>
                                            <span>On 24 Jun 2025</span>
                                            <Link to="/Blogdetails">
                                            10 Ways NRIs Can Resolve Family Disputes From Afar
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="recent-blog-widget-item" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}}>
                                        <img
                                            src={Teamdtlimg02}
                                            alt="blog-image"
                                        />
                                        <div className="recent-blog-widget-item-title">
                                            <span>On 24 Jun 2025</span>
                                            <Link to="/Blogdetails">
                                            10 Things Every NRI Should Know About OCI Card
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="recent-blog-widget-item" style={{display: "flex", flexDirection: "column", flex: "1", gap: "0px"}}>
                                        <img
                                            src={Teamdtlimg01}
                                            alt="blog-image"
                                        />
                                        <div className="recent-blog-widget-item-title">
                                            <span>On 24 Jun 2025</span>
                                            <Link to="/Blogdetails">
                                            7 Essential Personal Finance Tips for NRIs You Need to Know
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="blog-block">
                                <div className="tag-widget">
                                    <h4>Popular Tags</h4>
                                    <ul>
                                        <li className="active">
                                            <Link to="#">Finance</Link>
                                        </li>
                                        <li>
                                            <Link to="#">loanlift</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Investors</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Investors</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Credit Score</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="blog-block mb-0">
                                <div className="bolg-cta-widget">
                                    <div className="bolg-cta-widget-inner">
                                        <img src={Logo} alt="logo" />
                                        <h3>Premier Advisory Specialists for NRIs</h3>
                                        <p className="lead">
                                            <Link to="tel:+1 732-734-2800">
                                                <i className="flaticon-phone" /> +1 732-734-2800            
                                            </Link>
                                        </p>
                                        <Link to="/contact-us" className="btn btn-primary">
                                            Get Started <i className="flaticon-next" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Teamdetail;